import { useEffect } from 'react'

import { AppShell } from '@/components/layout/app-shell'
import { Toaster } from '@/components/toaster'
import { TooltipProvider } from '@/components/ui/tooltip'
import { useActivityStore } from '@/store/activity-store'

function App() {
  const theme = useActivityStore((s) => s.ui.theme)
  const hydrateFromPersistence = useActivityStore((s) => s.hydrateFromPersistence)

  // Applies the persisted/preferred theme to the document root. index.css's
  // `.dark` variant selector is what actually swaps the CSS variables.
  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark')
  }, [theme])

  // Restores previously loaded activities (and their edit history) from
  // IndexedDB once on mount (M7). A genuine "synchronize with an
  // external system" effect, not a derived-state one -- this is exactly
  // the sanctioned case for calling an async side effect from inside
  // `useEffect` per this codebase's established pattern (see
  // `set-gps-constant-dialog.tsx`'s doc comment for the same
  // distinction). `hydrateFromPersistence` itself no-ops if activities
  // are already loaded or if IndexedDB isn't available.
  useEffect(() => {
    void hydrateFromPersistence()
  }, [hydrateFromPersistence])

  return (
    <TooltipProvider delayDuration={200}>
      <AppShell />
      <Toaster />
    </TooltipProvider>
  )
}

export default App
